<template>
    <div>
        <vue-headful
                title="Falk Huth | Kenntnisse"
                description="IT-, Prozess- und sonstige Kenntnisse von Falk Huth (Auswahl)"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header>
                    <div class="md-title">IT-, Prozess- und sonstige Kenntnisse <small>(Auswahl)</small></div>
                    <div class="md-subhead">
                        Mit den blau dargestellten Themen hatte ich bereits häufiger zu tun, mit den grauen Themen
                        bisher wenig bzw. seit langem nicht mehr. Bitte mit der Maus drüber fahren, um näherere
                        Erläuterungen zu sehen. <strong>TODO:</strong> Konkrete Einsatzfälle in Projekten sollen
                        demnächst angezeigt werden, wenn man draufklickt.
                    </div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <div class="md-body-2">
                                Auswahl an bekannten <u>Methoden</u> im IT-Umfeld
                            </div>
                            <md-chips>
                                <md-chip class="md-primary">Projektmanagement</md-chip>
                                <md-chip class="md-primary">Prozessanalyse</md-chip>
                                <md-chip class="md-primary">Change-Management</md-chip>
                                <md-chip class="md-primary">Digitaler Wandel</md-chip>
                                <md-chip class="md-primary">Qualitätsmanagement</md-chip>
                                <md-chip>Agile Software-Entwicklung</md-chip>
                            </md-chips>
                            <div class="md-body-2">
                                Bekannte <u>Lösungskonzepte</u> (Auswahl)
                            </div>
                            <md-chips>
                                <md-chip class="md-primary">
                                    <span>ECM</span>
                                    <md-tooltip md-direction="bottom">Enterprise-Content-Management</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>DMS</span>
                                    <md-tooltip md-direction="bottom">Document-Management-System</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>BPM / Workflow</span>
                                    <md-tooltip md-direction="bottom">Business-Process-Management / Workflow</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>CRM</span>
                                    <md-tooltip md-direction="bottom">Customer-Relationship-Management</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>ERP</span>
                                    <md-tooltip md-direction="bottom">Enterprise-Resource-Planung</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>CMS</span>
                                    <md-tooltip md-direction="bottom">Content-Management-System</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>SaaS / Cloud</span>
                                    <md-tooltip md-direction="bottom">Software-as-a-Service / Cloud</md-tooltip>
                                </md-chip>
                            </md-chips>
                            <div class="md-body-2">
                                <u>Produkte</u> (Auswahl bekannter <u>Anwendungssysteme</u>)
                            </div>
                            <md-chips>
                                <md-chip class="md-primary">
                                    <span>ECM/DMS-Plattform d.3ecm</span>
                                    <md-tooltip md-direction="bottom">Produkt der Firma d.velop AG, Systemhaus: codia Software GmbH</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>ERP-System proALPHA</span>
                                    <md-tooltip md-direction="bottom">Produkt der proALPHA Business Solution GmbH</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Campusmanagement HISinOne</span>
                                    <md-tooltip md-direction="bottom">Produkt der HIS eG. Umfasst z.B. die Bereiche Studierenden-, Alumni- und Forschungsverwaltung</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Hochschul-ERP-System HIS</span>
                                    <md-tooltip md-direction="bottom">Produkt der HIS eG. Umfasst z.B. die Bereiche Finanzen, Personal, Bau und Controlling</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>CMS Typo3</span>
                                    <md-tooltip md-direction="bottom">Open-Source-Produkt zur Erstellung von Webseiten und berechtigungsabhängigen Änderungsmöglichkeiten der Inhalte</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>SAP / Navision / Bison</span>
                                    <md-tooltip md-direction="bottom">Im Rahmen von Studium bzw. Projekten mit diesen ERP-Systemen befasst, ohne tiefgreifende Kenntnisse zu haben</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Teilkompontenten der genannten Produkte</span>
                                    <md-tooltip md-direction="bottom">z.B. bietet proALPHA DMS-, CRM- und Workflow-Funktionen von Hause aus, ebenso bietet d.3ecm Workflows, Formulare oder Cloud-Konzepte.</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Office-Produkte</span>
                                    <md-tooltip md-direction="bottom">Standard-Werkzeuge wie Outlook, Word, Excel, Powerpoint oder Visio, die für die tägliche Arbeit immer wieder notwendig sind.</md-tooltip>
                                </md-chip>
                            </md-chips>
                            <div class="md-body-2">
                                Auswahl an <u>Prozessen</u>, die bereits für meine IT-Projekte wichtig waren
                            </div>
                            <md-chips>
                                <md-chip class="md-primary">
                                    <span>Vertrieb</span>
                                    <md-tooltip md-direction="bottom">z.B. Lead-/Opportunity-Management, Forecast/Pipeline, Provision</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Service</span>
                                    <md-tooltip md-direction="bottom">z.B. Serviceaufträge, Rückmeldungen, Serviceeinsatzplanung, Lagerbuchungen</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Öffentliche Verwaltung</span>
                                    <md-tooltip md-direction="bottom">z.B. Beschaffung/Vergabe, Mittelverwaltung/Budget, Stellenbesetzung</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Forschung/Förderprojekte</span>
                                    <md-tooltip md-direction="bottom">z.B. Drittmittelprojektanzeige, Fördermittelgeber, Projektantrag, Aufstockung/Umwidmung, Mittelabruf</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Digitale Workflows</span>
                                    <md-tooltip md-direction="bottom">z.B. Rechnungsfreigabe per elektronischem Workflow, wobei das Original in der Buchhaltung bleibt</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Studierendenverwaltung</span>
                                    <md-tooltip md-direction="bottom">z.B. Studienbewerbung, Immatrikulation, Gebühren, Modulbelegung, Prüfungen, Abschluss</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Internationalisierung</span>
                                    <md-tooltip md-direction="bottom">z.B. andere Sprachen/Währungen/Zeitzonen/Zeichensätze, Beachtung möglicher Wartungszeitfenster</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Konzern-Controlling</span>
                                    <md-tooltip md-direction="bottom">z.B. monatsweise Abgrenzung zum Reporting nach IFRS, genaue Forecasts, Aktienkurse leicht zu gefährden</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Verkauf von Baustoffen</span>
                                    <md-tooltip md-direction="bottom">z.B. Verwaltung von Bauobjekten, um mehrere Anfragen zu einem Objekt zu identifizieren und vertrieblich zu beachten</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Abrechnung von SaaS</span>
                                    <md-tooltip md-direction="bottom">z.B. Verwaltung der Vertragsbestandteile, Messung des Verbrauchs, Abrechnung je nach Tarif, Beachtung von Sondervereinbarungen unterschiedlichste Art</md-tooltip>
                                </md-chip>
                            </md-chips>
                            <div class="md-body-2">
                                Ausgewählte Tools für die <u>Software-Entwicklung</u>, deren Anwendung/Konfiguration mir vertraut ist
                            </div>
                            <md-chips>
                                <md-chip class="md-primary">
                                    <span>GIT, vorher SVN/CVS</span>
                                    <md-tooltip md-direction="bottom">Versionsverwaltung und Verbesserung der Arbeit im Team</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Jira, YouTrack, OTRS, Mantis</span>
                                    <md-tooltip md-direction="bottom">Ticketsysteme, wobei mit Jira auch Anforderungssammlung und agiler Entwicklungsprozess unterstützt werden</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Jenkins, Maven, Ant, NodeJS, PHP Composer, MS Installer</span>
                                    <md-tooltip md-direction="bottom">Werkzeuge, die zum Bereitstellung von Software dienen (Deployment) oder sogar die Installation mit übernehmen</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Eclipse, PhpStorm, Visual Studio</span>
                                    <md-tooltip md-direction="bottom">Ausgewählte Programmierumgebungen, die ich in den letzten Jahren benutzt hatte</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Testmanagement mit Testlink</span>
                                    <md-tooltip md-direction="bottom">Erstellung von Testfällen und Dokumentation durchgeführter Software-Tests</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>Testautomatisierung</span>
                                    <md-tooltip md-direction="bottom">Thema Unit-Testing ist bekannt, komplexe Testautomatisierung habe ich nie selbst gemacht</md-tooltip>
                                </md-chip>
                            </md-chips>
                            <div class="md-body-2">
                                Von mir beherrschte <u>Programmiersprachen</u> (Auswahl, nur aus der letzten Zeit)
                            </div>
                            <md-chips>
                                <md-chip class="md-primary">
                                    <span>Java / Groovy</span>
                                    <md-tooltip md-direction="bottom">d.3ecm arbeitet mit Groovy-Skripten, die eine Erweiterung von Java sind. Daher kümmere ich mich wieder aktiver um Java.</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>PHP 7.2, Zend, Doctrine</span>
                                    <md-tooltip md-direction="bottom">Serverseite von Webanwendungen auf PHP-Basis und Nutzung von PHP-Frameworks</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>JavaScript + VueJS o.ä.</span>
                                    <md-tooltip md-direction="bottom">Clientseitiges Skripting bis hin zu kompletten Client-Applikationen mit VueJS, wie z.B. dieser Homepage</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>HTML/CSS/XML/JSON/...</span>
                                    <md-tooltip md-direction="bottom">Grundtechnologien für die Darstellung von Webseiten und den Datenaustausch zwischen Systemen</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Progress 4GL</span>
                                    <md-tooltip md-direction="bottom">Eigene Programmiersprache, die zum Anpassen von proALPHA benötigt wird, da proALPHA auf der Progress-Datenbank basiert</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>C/C++/VB/Pascal/Delphi</span>
                                    <md-tooltip md-direction="bottom">alles mal irgendwann programmiert, nur lange her</md-tooltip>
                                </md-chip>
                            </md-chips>
                            <div class="md-body-2">
                                Auswahl an <u>Datenbank-Systemen</u>, mit denen ich schon aktiv zu tun hatte
                            </div>
                            <md-chips>
                                <md-chip class="md-primary">
                                    <span>MS-SQL-Server</span>
                                    <md-tooltip md-direction="bottom">derzeit aktiver Einsatz im Zusammenhang mit d.3ecm</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>Progress OpenEdge</span>
                                    <md-tooltip md-direction="bottom">Datenbank- und Applikationsbasis für das ERP-System proALPHA, wo ich über jahrelange Erfahrungen verfüge</md-tooltip>
                                </md-chip>
                                <md-chip class="md-primary">
                                    <span>mySQL</span>
                                    <md-tooltip md-direction="bottom">Häufigste Datenbank bei Internet-Providern, ausgiebige Erfahrungen</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>PostgreSQL</span>
                                    <md-tooltip md-direction="bottom">Verwendung nur im Zusammenhang mit dem Auslesen von Daten aus HIS-Datenbanken</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>MS Access</span>
                                    <md-tooltip md-direction="bottom">Berührungspunkte sind da nur sporadisch, wird aber an der Hochschule viel eingesetzt</md-tooltip>
                                </md-chip>
                                <md-chip>
                                    <span>ODBC/JDBC-Treiber der Hersteller</span>
                                    <md-tooltip md-direction="bottom">Verwendung als Treiber, wenn diese für den Zugriff benötigt werden</md-tooltip>
                                </md-chip>
                            </md-chips>
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Kenntnisse"
    }
</script>

<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
</style>
